import { Component, OnInit } from '@angular/core';
import { CustomerInterface } from '../../models/customer.interface';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import {
  ECustomerActions,
  UpdateCustomerSuccess,
  UpdatePersonnelInformationCustomer
} from '../../store/actions/customer.actions';
import { Router } from '@angular/router';
import { CustomerStorageService } from '../../services/customer-storage.service';
import { ConstsHelper } from '../../../../helpers/consts.helper';
import { CheckPasswordInterfaceState } from '../../../shared/store/state/check-password.state';
import { UpdateSelectedProcedure } from '../../../shared/store/actions/selected-procedure.actions';
import { CheckPasswordInterface } from '../../../shared/models/check-password.interface';
import { Actions, ofType } from '@ngrx/effects';
import { UpdateMfaVisibility } from '../../../shared/store/actions/mfa.actions';
import { ExtranetService } from '../../../shared/services/extranet.service';
import { UpdateCheckPasswordVisibility } from '../../../shared/store/actions/check-password.actions';
import { environment } from '../../../../../environments/environment';
import { CustomerService } from '../../services/customer.service';

@Component({
    selector: 'app-update-account',
    templateUrl: './update-account.component.html',
    styleUrls: ['./update-account.component.css'],
    standalone: false
})
export class UpdateAccountComponent implements OnInit {

  customer: CustomerInterface;
  customerForm: FormGroup;
  customerFormSubmitted: boolean;
  routingAddressList: Array<{ value: string; label:string; }>;
  isPro: boolean;
  brand: string;
  passwordResponse: CheckPasswordInterface;
  errors: any = {
    email: { required: `L'adresse email est obligatoire.`,
      pattern: `L'adresse email saisie n'est pas valide.`
    },
    password: {
      required: `Le mot de passe est obligatoire.`,
      pattern: `Votre mot de passe est invalide.`
    },
    phoneNumber: {
      required: `Un numéro de téléphone est obligatoire.`,
      pattern: `Veuillez saisir un numéro de téléphone composé de 10 chiffres et commençant par 0.`,
    },
    routingAddress: {
      pattern: `L'adresse de routage saisie n\'est pas valide.`
    },
  };

  constructor(
      private formBuilder: FormBuilder,
      private store: Store<any>,
      private actions$: Actions,
      private customerStorage: CustomerStorageService,
      private router: Router,
      private extranetService: ExtranetService,
      private customerService: CustomerService,
  ) {}

  ngOnInit() {
    this.customerForm = null;
    this.routingAddressList = [];
    this.brand = environment.data.brand;
    this.store.pipe(select(ConstsHelper.REDUCER_CHECK_PASSWORD)).subscribe((response: CheckPasswordInterfaceState) => {
      if (response.result && response.result.isValid === true) {
        this.passwordResponse = response.result;
      }
    });

    this.actions$.pipe(ofType(ECustomerActions.UpdateCustomerSuccess)).subscribe((response: UpdateCustomerSuccess) => {
      this.store.dispatch(new UpdateCheckPasswordVisibility({visibility: false, isValid: false, password: null, page: 'info'}));
      this.router.navigate(['/compte/infos']);
    });

    if (!this.passwordResponse || this.passwordResponse.isValid === false) {
      this.router.navigate(['compte/infos']);
    }
    this.customer = this.customerStorage.getCustomer();
    this.isPro = [null, ''].indexOf(this.customer.siret) == -1;
    this.customerFormSubmitted = false;
    if (this.isPro) {
      this.customerService.getRoutingAddressList(this.customer.siret).subscribe(result => {
        this.routingAddressList = result;
        this.initForm();
      });
    } else {
      this.initForm();
    }
  }

  /**
   * Init form
   */
  initForm() {
    this.customerForm = this.formBuilder.group({});
    this.customerForm.addControl('email', this.formBuilder.control(this.customer.email, [Validators.required, Validators.pattern(ConstsHelper.emailPattern)]));
    this.customerForm.addControl('phoneNumber', this.formBuilder.control(this.customer.phoneNumber, [Validators.required, Validators.pattern('^(\\+33|0)[1-9][0-9]{8}$')]));
    if (this.isPro) {
      let routingAddressValue = '';
      if (this.routingAddressList.findIndex(obj => obj.value == this.customer.routingAddress) !== -1) {
        routingAddressValue = this.customer.routingAddress;
      }
      this.customerForm.addControl('routingAddress', this.formBuilder.control(routingAddressValue, [Validators.pattern(ConstsHelper.routingAddressPattern)]));
      this.customerForm.addControl('codeService', this.formBuilder.control(this.customer.codeService));
      this.customerForm.addControl('numeroCommande', this.formBuilder.control(this.customer.numeroCommande));
      this.customerForm.addControl('buyerReference', this.formBuilder.control(this.customer.buyerReference));
    }
  }

  /**
   * Save data
   */
  save() {
    this.customerFormSubmitted = true;
    if (this.customerForm.valid) {
      this.customer.email = this.customerForm.get('email').value;
      this.customer.phoneNumber = this.customerForm.get('phoneNumber').value;
      this.customer.password = this.passwordResponse.password;
      if (this.isPro) {
        this.customer.routingAddress = this.customerForm.get('routingAddress').value;
        this.customer.codeService = this.customerForm.get('codeService').value;
        this.customer.numeroCommande = this.customerForm.get('numeroCommande').value;
        this.customer.buyerReference = this.customerForm.get('buyerReference').value;
      }
      if (this.extranetService.getSupportUser()) {
        this.store.dispatch(new UpdatePersonnelInformationCustomer(this.customer));
        this.store.dispatch(new UpdateCheckPasswordVisibility({visibility: false, isValid: false, password: null, page: 'info'}));
      } else {
        this.store.dispatch(
            new UpdateMfaVisibility(
                {
                  visibility: true,
                  action: 'change_email',
                  step: 1,
                  destination: [null, ''].indexOf(this.customer.email) === -1 ? this.customer.email : null,
                  code: null,
                  errorMessage: null,
                  effect: UpdatePersonnelInformationCustomer,
                  effectData: this.customer
                }
            )
        );
      }
      this.customerFormSubmitted = false;
    }
  }

  cancel() {
    this.store.dispatch(new UpdateCheckPasswordVisibility({visibility: false, isValid: false, password: null, page: 'info'}));
    this.store.dispatch(new UpdateSelectedProcedure(''));
    this.router.navigate(['/compte/infos']);
  }

  getError(formControlName: string): string {
    let errorMsg = '';
    if (this.customerForm.controls[formControlName].invalid) {
      Object.keys(this.customerForm.controls[formControlName].errors).map(
          key => {
            errorMsg = this.errors[formControlName][key];
          }
      );
    }
    return errorMsg;
  }
}
